import styled from 'styled-components';

export const StyledPlaySimple = styled.div`
  font-family: var(--font-family), Arial;
  display: flex;
  flex-direction: column;
  align-items: end;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 17px 13px;
  background-color: #ffffff;
  background-image: ${(props: any) =>
      props.backgroundSrc ? `url("${props.backgroundSrc}")` : 'none'};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom;
  border-radius: 12px;
  color: #ffffff;


  .playSimple-bundle {
    &__products-container {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    &__product-img-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 5px;

      img {
        height: 104px;
      }
    }

    &__bundle-price {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      height: 60px;

      & .bundlePriceButton {
        padding: 5px 40px;
        background: linear-gradient(180deg, #51DE5E 0%, #2FAB3A 100%);
        box-shadow: inset 0 -4px 0 0 rgba(20, 128, 29, 1);
        font-size: 24px;
        width: auto;
      }
    }
    
    &__product-quantity-section {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    &__main-quantity {
      display: flex;
      align-items: center;
      margin-top: 15px;
      background: #8A8A8A;
      border-radius: 25px;
      width: fit-content;
      padding-right: 12px;
      min-width: 130px;

      img {
        width: 42px;
        height: 42px;
        border-radius: 20px;
        margin: 2px;
      }
    }

    &__main-quantity-text {
      flex-grow: 1;
      padding: 2px;
      font-size: 24px;
      font-weight: 700;

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      
      &__stroked {
        font-size: 12px;
        text-decoration: line-through;
      }
    }

    &__sub-products-quantity {
      display: flex;
      justify-content: space-between;
      position: relative;
      margin-top: 13px;

      & .product-image-container {
          position: static;
          
          .sub-product {
              position: absolute;
              width: 34px;
              height: 34px;
              top: -5px;
          }
          
        & .product {
          padding: 1px;
          width: 32px;
          height: 32px;
          background: #8A8A8A;
          border-radius: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      & .quantity {
        padding: 2px 24px 2px 40px;
        background: #8A8A8A;
        border-radius: 20px;
        font-size: 16px;
      }
    }

    &__header {
      width: 100%;

      & .ac-ribbon-badge--center {
        position: absolute;
        top: -12px;
        left: -2px;

        .ac-ribbon-badge {
          &__front {
            width: 140px;
            height: 24px;
            box-shadow: none;

            &__text {
              font-size: 14px;
              font-weight: 600;
              font-family: Montserrat, sans-serif;
              text-transform: uppercase;
              text-shadow: none
            }
          }

          & .ribbon-edge-right {
            display: none
          }
        }

      }

      &__ribbonBadge-arrow {
        position: absolute;
        top: -12px;
        left: 134px;
        width: 0;
        height: 0;
        border-left: 12px solid #8B34C3;
        border-top: 12px solid transparent;
        border-bottom: 12px solid transparent;
      }

      &__saleBadge {
        width: 64px;
        height: 64px;
        position: absolute;
        top: -13px;
        right: -13px;
        background: #4B4CFB;
        aspect-ratio: 1;
        clip-path: polygon(100% 50%, 88.64% 60.35%, 93.3% 75%, 78.28% 78.28%, 75% 93.3%, 60.35% 88.64%, 50% 100%, 39.65% 88.64%, 25% 93.3%, 21.72% 78.28%, 6.7% 75%, 11.36% 60.35%, 0% 50%, 11.36% 39.65%, 6.7% 25%, 21.72% 21.72%, 25% 6.7%, 39.65% 11.36%, 50% 0%, 60.35% 11.36%, 75% 6.7%, 78.28% 21.72%, 93.3% 25%, 88.64% 39.65%);
      }

    }
  }
}

@media (max-width: 768px) {
  margin-bottom: 8px;
}
` as any;
